module.exports = __webpack_public_path__ + "img/logo.abe0e038.png";